import { AppstoreOutlined } from '@ant-design/icons';
import React from 'react';
import { FormValidatorBuilder } from '../../../../../validator';
import { getParentValidationScope } from '../../../../../validator/utils/getParentValidationScope';
import { tran } from '../../../../translations/schema/TranslationSchema';
import type { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import type { IRowWidget } from './IRowWidget';
import { RowWidgetComponent } from './RowWidgetComponent';
import {
  RowWidgetConfigComponent,
  RowWidgetConfigSchema,
} from './RowWidgetConfigComponent';

/**
 * Widget di tipo Riga.
 * Mostra gli elementi figli in orizzontale.
 */
export const RowWidgetType: IWidgetType<IRowWidget> = {
  type: WidgetType.Row,
  mainType: WidgetMainType.Container,
  category: WidgetCategory.Container,
  name: 'Riga',
  icon: <AppstoreOutlined />,
  hasValue: false,
  formComponent: RowWidgetComponent,
  createFormSchema: ({ widget, parentScope, section, page }) => {
    const widgetScope = getParentValidationScope(widget, parentScope);

    return FormValidatorBuilder.createWidgetsSchemaShape(
      widget.children,
      section,
      page,
      widgetScope,
    );
  },
  configComponent: RowWidgetConfigComponent,
  configValidator: RowWidgetConfigSchema,
  previewComponent: RowWidgetComponent,
  translationSchema: tran.widget({}),
  rules: [],
  childrenLayoutStrategy: 'horizontal',
};
